
import Api from './Api.service';
export default class MenuService {

    static ObtenerMenu() {
        return Api.get('menu');
    }
    static ObtenerTodo() {
        return Api.get('menutodo');
    }
    static ObtenerMenuPadre() {
        return Api.get('menupadre');
    }
    static ObtenerUltimoOrden(menupadreid) {
        return Api.get(`menuultimoorden/${menupadreid}`);
    }
    static Insertar(model) {
        return Api.post('menuinsertar',model);
    }
    static Editar(model) {
        return Api.put('menueditar',model);
    }
    static Eliminar(menuid) {
        return Api.delete(`menu/${menuid}`);
    }

}
